export type SortColumnDirection = 'asc' | 'desc';
export interface SortField<T extends string> {
  field: T;
  active: boolean;
  direction: SortColumnDirection;
}

export const sortColumnDirectionTypes: SortColumnDirection[] = ['asc', 'desc'];
